import React, {useState, useEffect} from 'react'
import i18n from 'live/services/i18n';
import styled from 'styled-components'
import { Event, Value } from '../types';
import { Geocoding, format } from '../classes/Geocoding';

type Props = {     
    isActive?: boolean
    style?: any
    data: Event,
    addresses?: any,
    onClick?(): void
}

const Card = ({style = {}, data, addresses = {}, isActive,  onClick}: Props): JSX.Element => {
    
    const {title, start, end, locationBegin, locationEnd, values = []} = data || {values: []}

    const fillAdresses = (replaceByAddress, value: string) => {        
        if(replaceByAddress === 'locationBegin') return addresses[format(locationBegin)] 
        
        if(replaceByAddress === 'locationEnd')   return addresses[format(locationEnd)] 

        return value
    }

    return <WrapperCard style={style} isActive={isActive} onClick={onClick}>
        <HeaderCard> 
          <ul>
            <li className="header-card-title" style={{textAlign: 'start'}}>
              {title}
            </li>
            
            <li style={{textAlign: 'end', flex:'1'}}>
              <span className="header-date-title">{i18n('Start')}:</span>
              <span className="header-date-value" style={{marginRight: '12px'}}>{start?.text}</span>

              <span className="header-date-title">{i18n('End')}:</span>
              <span className="header-date-value">{end?.text}</span>
            </li>
          </ul>          
        </HeaderCard>

        <ContentCard>
          	<ul>
                {
                    values.map(({title, value, icon, replaceByAddress}, index) => {

                        let valueAux = fillAdresses(replaceByAddress, value)
        
                        const theObj = {__html:valueAux };

                        const valueToHtml = () =>{
                            return <span dangerouslySetInnerHTML={theObj} />
                        }
                        return <li key={index}>
                            <span className='content-card-title'>
                                {icon && <i className={icon}></i>}
                                {i18n(title)}:    
                            </span>

                            <span className='content-card-value'>
                                {valueToHtml()}
                            </span>
                        
                      </li>
                    })
                }
            </ul>
        </ContentCard>
    </WrapperCard>
}

export default Card;

const WrapperCard = styled.div`
	width: 100%;
    padding: 12px;
	border-radius: 3px;
    margin-bottom: 8px;
    padding-bottom: 0;
    border-style: solid;
    border-width: ${({isActive}) => isActive ? '2px' : '1px'};
    border-color: ${({theme, isActive}) => isActive ? theme['blue-500'] : theme['gray-400']};

    &:hover{
        background: #E1F0FF;
        cursor: pointer;
    }
`

const HeaderCard = styled.div`
	ul{
    	display: flex;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid ${({theme}) => theme['gray-400']};

        li{
            line-height: 16px;
            font-style: normal;  
        }

        .header-card-title{            
            font-weight: 600;
            font-size: 13px;
            text-transform: uppercase;
            color: ${({theme}) => {                
                return theme['gray-700'];
            }};
        }

        .header-date-title{
            font-weight: 400;
            font-size: 13px;
        }

        .header-date-value{
            font-weight: 600;
            font-size: 12px;
        }

        .header-date-title, .header-date-value{
            color: ${({theme}) => theme['gray-700']};
        }
    }
`

const ContentCard = styled.div`
	font-weight: 600;
	font-size: 11px;
    color: ${({theme}) => theme['gray-700']};
    margin-bottom: 0;

    ul{
        margin-bottom: 0;
    }

    li{
        /* margin-bottom: 10.5px; */
        height: 26px;
        white-space: nowrap;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis; 

        &:last-of-type{
            margin-bottom: 0;
        }
    }

    .content-card-title{
        font-weight: 400;
        font-size: 11px;
        margin-right: 5px;
        line-height: 16px;
    }

    .content-card-value{
        font-weight: 600;
        font-size: 11px;
        line-height: 16px;
    }

    i{
        margin-right: 5px;
        color: ${({theme}) => theme['gray-600']}
    }
`